import script from "./Step3CreandoGafete.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3CreandoGafete.vue?vue&type=script&setup=true&lang=js"

import "./Step3CreandoGafete.vue?vue&type=style&index=0&id=30ad9034&lang=css"

const __exports__ = script;

export default __exports__